<template>
  <div class="wrapper-aside-filters">
    <transition name="fade">
      <div class="turn-off-the-lights" v-show="turnOffTheLight"></div>
    </transition>
    <div class="aside-menu" :style="style">
      <div class="row">
        <div class="col text-center">
          <h5 class="filter">
            {{ $t('menu.filter.filters') }}
            <i
              @click="hideMenu"
              variant="danger"
              class="fas fa-times pull-right"
              style="cursor: pointer"
            ></i>
          </h5>
        </div>
      </div>

      <div class="row py-3">
        <div class="col">
          <b-dropdown
            v-if="
              metricOptions.nps15 ||
              metricOptions.nps010 ||
              metricOptions.ces15 ||
              metricOptions.csat15 ||
              metricOptions.csat15Average ||
              metricOptions.csat0to10Average ||
              metricOptions.review5Stars
            "
            block
            variant="outline-primary"
            class="btn-block"
            menu-class="w-100 p-2"
            no-caret
          >
            <template slot="button-content">
              <span class="button--formater">
                {{ $t('menu.filter.provincialMetric') }}
                {{ storesMetric ? `- ${storesMetric}` : '' }}
              </span>
            </template>
            <b-dropdown-item href="#" v-if="metricOptions.nps15">
              <span
                class="string--formater"
                :title="`${this.$t('menu.navbar.nps15')}`"
                @click="changeMetric('nps-1-5')"
              >
                {{ $t('menu.filter.NPS1a5') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item v-if="metricOptions.nps010" href="#">
              <span
                class="string--formater"
                :title="`${this.$t('menu.navbar.nps010')}`"
                @click="changeMetric('nps-0-10')"
              >
                {{ $t('menu.filter.NPS010') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" v-if="metricOptions.ces15">
              <span
                class="string--formater"
                :title="`${this.$t('menu.filter.CES1a5')}`"
                @click="changeMetric('ces-1-5')"
              >
                {{ $t('menu.filter.CES1a5') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" v-if="metricOptions.csat15">
              <span
                class="string--formater"
                :title="$t('menu.filter.CSAT1to5')"
                @click="changeMetric('csat-1-5')"
              >
                {{ $t('menu.filter.CSAT1to5') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" v-if="metricOptions.csat15Average">
              <span
                class="string--formater"
                :title="$t('menu.filter.CSAT1to5')"
                @click="changeMetric('csat-1-5(media)')"
              >
                {{ $t('menu.filter.CSAT1to5Average') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" v-if="metricOptions.csat0to10Average">
              <span
                class="string--formater"
                :title="`${this.$t('menu.filter.CSAT0to10Average')}`"
                @click="changeMetric('csat-0-10(media)')"
              >
                {{ $t('menu.filter.CSAT0to10Average') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" v-if="metricOptions.review5Stars">
              <span
                class="string--formater"
                :title="$t('menu.filter.review5Stars')"
                @click="changeMetric('5-stars')"
              >
                {{ $t('menu.filter.review5Stars') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" v-if="metricOptions.likeDislike">
              <span
                class="string--formater"
                :title="$t('menu.filter.likeDislike')"
                @click="changeMetric('like-dislike')"
              >
                {{ $t('menu.filter.likeDislike') }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <p class="text-center mt-3" v-else>
            {{ $t('menu.filter.metricsUnavailable') }}
          </p>
        </div>
      </div>

      <div>
        <hr />
      </div>

      <div class="my-3">
        <div class="mb-3">
          <b-dropdown
            block
            variant="outline-primary"
            class="btn-block"
            menu-class="w-100 p-2"
            no-caret
          >
            <template slot="button-content">
              <span @click="updateListGroupAction" class="button--formater2"
                >{{ $t('menu.filter.filterAactionGroup') }}
                {{
                  ` ${
                    storesActionGroup && storesActionGroup !== undefined
                      ? `- ${storesActionGroup.name}`
                      : ''
                  }`
                }}
                <span
                  :title="`${this.$t('menu.filter.titleResetFilterData')}`"
                  class="eraser-icon"
                  @click="cleanActionGroupDataFilter"
                >
                  <i class="fas fa-eraser"></i>
                </span>
              </span>
            </template>
            <input
              type="text"
              class="form-control mb-2"
              v-model="groupName"
              @keyup="searchByGroupName"
              @keypress.enter="searchByGroupName"
            />
            <b-dropdown-item
              href="#"
              v-for="(group, i) in hintsGroups"
              :key="i"
              @click="setActionGroup(false, group)"
            >
              <span class="string--formater" :title="group.name">
                {{ group.name }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div>
          <b-dropdown
            block
            variant="outline-primary"
            class="btn-block"
            menu-class="w-100 p-2"
            no-caret
          >
            <template slot="button-content">
              <span @click="updateListActions()" class="button--formater">
                {{ $t('menu.filter.filterAction') }}
                <!-- {{ `Filtro por ${action || myActionName}` }} -->
                <span
                  :title="`${this.$t('menu.filter.titleResetFilterData')}`"
                  class="eraser-icon"
                  @click="cleanActionDataFilter"
                >
                  <i class="fas fa-eraser"></i>
                </span>
              </span>
            </template>
            <input
              type="text"
              class="form-control mb-2"
              v-model="action"
              @keyup="filterAction"
              @keypress.enter="enterSetValAction()"
            />
            <div v-if="hintsAction && hintsAction.length > 0 && !loadingAction">
            <b-dropdown-item
              href="#"
              v-for="(item, i) in hintsAction"
              :key="i"
              @click="setValAction(false, item._id, item.name)"
            >
              <span class="string--formater" :title="item.name">
                {{ item.name }}
              </span>
            </b-dropdown-item>
            </div>
            <div v-if="loadingAction">
              Carregando...
            </div>
            <div v-if="!loadingAction && hintsAction && hintsAction.length === 0">
              <span>Sem ações.</span>
            </div>
          </b-dropdown>
        </div>
      </div>

      <div v-if="allGroups.length > 1">
        <hr />
      </div>

      <div class="row">
        <div class="col">
          <div v-if="ih1.listFilters.length !== 0" class="row mt-3 mb-3 h">
            <div class="col">
              <b-dropdown
                id="dropih1"
                block
                variant="outline-primary"
                class="btn-block"
                menu-class="w-100 p-2"
                no-caret
              >
                <template slot="button-content">
                  <span @click="allPeriod" class="button--formater">
                    {{
                      $t('menu.filter.filterIh1', {
                        ih1: `${
                          boxIh1 || company.indicatorIh1
                            ? company.indicatorIh1
                            : 'indicador 1'
                        }`,
                      })
                    }}
                  </span>
                </template>
                <input
                  type="text"
                  class="form-control mb-2"
                  v-model="boxIh1"
                  @keyup="searchIh1"
                  @keypress.enter="enterSetValIh1"
                />
                <b-dropdown-item
                  href="#"
                  v-for="(item, i) in hintsIh1"
                  :key="i"
                  @click="setValIh1(false, item._id)"
                >
                  <span class="string--formater" :title="item.corporate_name">
                    {{ item.corporate_name }}
                  </span>
                </b-dropdown-item>
                <div class="pagination-area-ih1">
                  <paginate
                    v-model="currentPage"
                    :pageCount="Math.ceil(ih1.total / 20)"
                    :clickHandler="loadIh1Ih2"
                    :prevText="'‹'"
                    :nextText="'›'"
                    :activeClass="'active'"
                    :containerClass="'pagination b-pagination'"
                    :pageClass="'page-item'"
                  >
                  </paginate>

                  <div class="pull-right" style="margin-top: -35px">
                    <b-spinner
                      v-if="loadingIh1"
                      variant="primary"
                      label=""
                    ></b-spinner>
                  </div>
                </div>
              </b-dropdown>
            </div>
          </div>

          <div v-if="ih2.listFilters.length !== 0" class="row mt-3 mb-3">
            <div class="col">
              <b-dropdown
                block
                variant="outline-primary"
                class="btn-block"
                menu-class="w-100 p-2"
                no-caret
              >
                <template slot="button-content">
                  <span @click="allPeriod" class="button--formater">
                    {{
                      $t('menu.filter.filterIh2', {
                        ih2: `${
                          company.indicatorIh2
                            ? company.indicatorIh2
                            : 'indicador 2'
                        }`,
                      })
                    }}
                  </span>
                </template>
                <input
                  type="text"
                  class="form-control mb-2"
                  v-model="boxIh2"
                  @keyup="searchIh2"
                  @keypress.enter="enterSetValIh2"
                />
                <b-dropdown-item
                  href="#"
                  v-for="(item, i) in hintsIh2"
                  :key="i"
                  @click="setValIh2(false, item._id)"
                >
                  <span class="string--formater" :title="item.corporate_name">
                    {{ item.corporate_name }}
                  </span>
                </b-dropdown-item>

                <div class="pagination-area-ih1">
                  <paginate
                    v-model="currentPageIh2"
                    :pageCount="Math.ceil(ih2.total / 20)"
                    :clickHandler="loadIh2"
                    :prevText="'‹'"
                    :nextText="'›'"
                    :activeClass="'active'"
                    :containerClass="'pagination b-pagination'"
                    :pageClass="'page-item'"
                  >
                  </paginate>

                  <div class="pull-right" style="margin-top: -35px">
                    <b-spinner
                      v-if="loadingIh2"
                      variant="primary"
                      label=""
                    ></b-spinner>
                  </div>
                </div>
              </b-dropdown>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <b-dropdown
                block
                variant="outline-primary"
                class="btn-block"
                menu-class="w-100 p-2"
                no-caret
              >
                <template slot="button-content">
                  <span class="button--formater2" @click="updateListIndicators()">
                    {{
                      storeIndicatorDataName
                        ? `Indicador - ${storeIndicatorDataName}`
                        : 'Indicador'
                    }}
                    <span
                      :title="`${this.$t('menu.filter.titleResetFilter')}`"
                      class="eraser-icon"
                      @click="cleanIndicatorFilter"
                    >
                      <i class="fas fa-eraser"></i>
                    </span>
                  </span>
                </template>
                <input
                  type="text"
                  class="form-control mb-2"
                  v-model="indicatorSelected"
                  @keyup="filterIndicator"
                  @keypress.enter="setIndicatorValue(indicatorSelected)"
                />
                <b-dropdown-item
                  href="#"
                  v-for="(indicator, i) in getIndicatorsPaginate"
                  :key="i"
                  @click="setIndicatorValue(indicator.text)"
                >
                  <span class="string--formater" :title="indicator.text">
                    <div class="list">
                      <div class="list-element">{{ indicator.text }}</div>
                    </div>
                  </span>
                </b-dropdown-item>
                <button id="loadmore" class="btn-loadmore" @click="loadMore">
                  Carregar mais>>
                </button>
              </b-dropdown>
            </div>
          </div>

          <div class="row" v-if="storeIndicatorDataName">
            <div class="col" v-if="!isDateIndicator(storeIndicatorDataName)">
              <b-dropdown
                block
                variant="outline-primary"
                class="btn-block"
                menu-class="w-100 p-2"
                no-caret
                :disabled="loading"
              >
                <template slot="button-content">
                  <span
                    @click="updateListIndicatorValue"
                    class="button--formater2"
                  >
                    {{ checkIndicatorData() }}
                    <span
                      :title="`${this.$t('menu.filter.titleResetFilterData')}`"
                      class="eraser-icon"
                      @click="cleanIndicatorDataFilter"
                    >
                      <i class="fas fa-eraser"></i>
                    </span>
                  </span>
                </template>
                <input
                  type="text"
                  class="form-control mb-2"
                  v-model="indicatorDataSelected"
                  @keyup="filterIndicatorData"
                  @keypress.enter="handleIndicatorData(indicatorDataSelected)"
                />
                <div v-if="!loadingIndicatorValue">
                  <b-dropdown-item
                    href="#"
                    v-for="(item, i) in getIndicatorsValuePaginate"
                    :key="i"
                    @click="handleIndicatorData(item.text, item.key)"
                  >
                    <span class="string--formater" :title="item.text">
                      {{ item.text }}
                    </span>
                  </b-dropdown-item>
                </div>
                <div v-else>
                  <div class="text-center">
                    <b-spinner
                      variant="success"
                      type="grow"
                      label="Spinning"
                      class="bg-primary"
                    ></b-spinner>
                  </div>
                </div>
                <button
                  id="loadmore-indic-value"
                  class="btn-loadmore"
                  @click="loadMoreIndicValue"
                >
                  Carregar mais>>
                </button>
              </b-dropdown>
            </div>
            <div class="col choose-date" v-else>
              <div style="padding: 7px 0px">
                <strong> {{ $t('dashboard.period') }}: </strong>
                <span>
                  <span style="font-weight: 100">{{ showPeriod() }}</span>
                </span>
                <vc-date-picker
                  :locale="countryLanguage"
                  mode="range"
                  v-model="dates"
                  color="green"
                  :max-date="maxDate"
                >
                  <font-awesome-icon
                    :icon="['fas', 'calendar-alt']"
                    class="ml-2 calendar-icon"
                    style="font-size: 18px"
                  />
                </vc-date-picker>
              </div>
              <div
                style="position: absolute; right: 5px"
                id="selectDateOption;"
              >
                <b-form-select
                  v-model="indCalendarDates.selected"
                  @change="selectOption(indCalendarDates.selected)"
                  :options="fastFilter"
                ></b-form-select>
              </div>
            </div>
          </div>

          <div class="row"></div>
        </div>
      </div>

      <div class="container" v-if="storeMyActionsIds.length > 0">
        <div class="row">
          <div class="col-12 text-left mb-2 text-size">Ações</div>
          <div class="col-12 filters-overflow">
            <div class="three-column">
              <div
                v-for="(actionId, indexAction) in storeMyActionsIds"
                :key="indexAction"
                class="tag-green"
              >
                <div class="hide-text">
                  <span :id="`tooltip-action-${indexAction}`">{{
                    returnActionName(actionId)
                  }}</span>
                </div>
                <span
                  style="cursor: pointer"
                  @click="removeActionById(actionId)"
                  >x</span
                >
                <b-tooltip
                  :target="`tooltip-action-${indexAction}`"
                  triggers="hover"
                  placement="top"
                >
                  {{ returnActionName(actionId) }}
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="container"
        v-if="storeMyHierarchies1 && storeMyHierarchies1.length > 0"
      >
        <hr />
        <div class="row">
          <div class="col-12 text-left mb-2 text-size">
            <template v-if="this.company.indicatorIh1">{{
              this.company.indicatorIh1
            }}</template>
            <template v-else>Filiais (ih1)</template>
          </div>
          <div class="col-12 filters-overflow">
            <div class="three-column">
              <div
                v-for="(myIh1Id, indexMyIh1) in storeMyHierarchies1"
                :key="indexMyIh1"
                class="tag-blue"
              >
                <div class="hide-text">
                  <span :id="`tooltip-ih1-${indexMyIh1}`">
                    {{ returnMyIh1Name(myIh1Id) }}
                  </span>
                </div>
                <span style="cursor: pointer" @click="removeIh1ById(myIh1Id)"
                  >x</span
                >
                <b-tooltip
                  :target="`tooltip-ih1-${indexMyIh1}`"
                  triggers="hover"
                  placement="top"
                >
                  {{ returnMyIh1Name(myIh1Id) }}
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="container"
        v-if="storeMyHierarchies2 && storeMyHierarchies2.length > 0"
      >
        <hr />
        <div class="row">
          <div class="col-12 text-left mb-2 text-size">
            <template v-if="this.company.indicatorIh2">{{
              this.company.indicatorIh2
            }}</template>
            <template v-else>Ih2</template>
          </div>
          <div class="col-12 filters-overflow">
            <div class="three-column">
              <div
                v-for="(myIh2Id, indexMyIh2) in storeMyHierarchies2"
                :key="indexMyIh2"
                class="tag-green"
              >
                <div class="hide-text">
                  <span :id="`tooltip-ih2-${indexMyIh2}`">
                    {{ returnMyIh2Name(myIh2Id) }}
                  </span>
                </div>
                <span style="cursor: pointer" @click="removeIh2ById(myIh2Id)"
                  >x</span
                >
                <b-tooltip
                  :target="`tooltip-ih2-${indexMyIh2}`"
                  triggers="hover"
                  placement="top"
                >
                  {{ returnMyIh2Name(myIh2Id) }}
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <hr />
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-primary btn-block" @click="apply">
            {{ $t('menu.filter.conclude') }}
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <button
            class="btn btn-outline-primary btn-block"
            @click="resetFilters"
          >
            {{ $t('menu.filter.clearFilter') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { format, lightFormat } from 'date-fns';
import Paginate from 'vuejs-paginate';
import hintBox from '@/components/atoms/hint-box';
import EventBus from '../../../eventBus';
import api from '../../../services/api';

const toLower = (text) => text.toString().toLowerCase();
const searchByItem = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(`${item.corporate_name}`).includes(toLower(term)),
    );
  }
  return items;
};
const searchByItemAction = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(`${item.name}`).includes(toLower(term)),
    );
  }
  return items;
};

const searchByIndicatorText = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(`${item.text}`).includes(toLower(term)),
    );
  }
  return items;
};

export default {
  name: 'AsideMenu',

  components: {
    hintBox,
    Paginate,
  },

  data: () => ({
    loading: false,
    style: {
      width: '550px',
      right: '-550px',
    },
    groupName: null,
    turnOffTheLight: false,
    boxIh1: null,
    boxIh2: null,
    action: null,
    metric: '0',
    hintsIh1: [],
    hintsIh2: [],
    hintsAction: [],
    hintsGroups: [],
    metricOptions: {},
    indicators: null,
    userAuth: null,
    allIndicatorData: null,
    indicatorSelected: null,
    indicatorDataSelected: null,
    indicatorFilter: null,
    indicatorDataFilter: null,
    dateIndicators: null,
    dates: {
      start: null,
      end: +new Date(),
      selected: 'Personalizado',
    },
    myDates: {
      start: null,
      end: null,
      selected: 'Personalizado',
    },
    countryLanguage: 'pt',
    fastFilter: [],
    maxDate: new Date(),
    indCalendarDates: {
      end: null,
      selected: null,
      start: null,
    },
    limit: 20,
    limitValue: 20,
    ih1Limit: 20,
    ih1Page: 1,
    currentPage: 1,
    currentPageIh2: 1,
    loadingIh1: false,
    loadingIh2: false,
    storesMetric: null,
    storesActionGroup: {
      name: 'Sem classificação',
      _id: null
    },
    storesActions: '',
    storeMyActionsIds: [],
    storeMyActionName: '',
    storeMyActionId: '',
    storeMyHierarchies1: [],
    storeMyHierarchies1Id: '',
    storeMyHierarchies2: [],
    storeMyHierarchies2Id: '',
    storeIndicatorDataValue: '',
    storeIndicatorDataKey: '',
    storeIndicatorDataPeriod: '',
    storeIndicatorDataName: '',
    loadingIndicatorValue: false,
    loadingAction: false,
  }),

  watch: {
    storesMetric: async function watchStoreMetric(metric) {
      await this.getAllActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        params: {
          type: metric,
          groupId: this.storesActionGroup._id
            ? this.storesActionGroup._id
            : this.actionGroupData._id,
        },
      });

      this.hintsAction = this.allActions;
    },

    storesActionGroup: async function watchStoresActionGroup(group) {
      let actionGroupData = {};
      if (!group.metric) {
        if (this.metric !== this.company.favoriteMetric) {
          this.storesMetric = this.company.favoriteMetric;
          this.metric = this.company.favoriteMetric;

          actionGroupData._id = group._id;
          actionGroupData.name = group.name;
        } else {
          actionGroupData = {
            _id: group._id,
            name: group.name,
          };
        }
      } else if (this.metric !== group.metric) {
        this.storesMetric = group.metric;

        actionGroupData._id = group._id;
        actionGroupData.name = group.name;
      } else {
        actionGroupData = {
          _id: group._id,
          name: group.name,
        };
      }

      if (!this.company.indicatorIh1) {
        this.company.indicatorIh1 = 'indicador 1';
      }

      await this.getAllActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        params: {
          type: this.storesMetric,
          groupId: this.storesActionGroup._id,
          // groupId: this.storesActionGroup._id
          //   ? this.storesActionGroup._id
          //   : this.actionGroupData._id,
        },
      });

      this.hintsAction = this.allActions;
    },

    storeMyActionsIds: async function watchStoreMyActionsIds() {
      if (this.storeMyActionsIds.length > 0) {
        this.storeMyActionName = this.returnActionName(
          this.storeMyActionsIds[0],
        );
      }
    },

    'ih1.listFilters': function watchIh1() {
      this.hintsIh1 = this.ih1.listFilters;
    },

    'ih2.listFilters': function watchIh2() {
      this.hintsIh2 = this.ih2.listFilters;
    },

    myIh1: function watchMyIh1(value) {
      if (value !== '0') {
        const ih1 = this.ih1.listFilters.find((obj) => obj._id === value);
        this.boxIh1 = ih1.corporate_name;
        this.hintsIh1 = this.ih1.listFilters;
        // this.cleanIndicatorFilter();
        // this.cleanIndicatorDataFilter();
      }
    },

    myHierarchies1: function watchMyHierarchies1(arrayIh1) {
      if (arrayIh1.length > 0) {
      }
    },

    myHierarchies2: function watchMyHierarchies2(arrayIh2) {
      if (arrayIh2.length > 0) {
        this.hintsIh2 = this.ih2.listFilters;
        this.limit = 20;
        this.limitValue = 20;
      }
    },

    myIh2: function watchMyIh2(value) {
      if (value !== '0') {
        const ih2 = this.ih2.listFilters.find((obj) => obj._id === value);
        this.boxIh2 = ih2.corporate_name;
        this.hintsIh2 = this.ih2.listFilters;
        this.limit = 20;
        this.limitValue = 20;
      }
    },

    myMetric: async function watchMyMetric(value) {
      this.storeMyActionsIds = [];

      await this.getAllActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        params: {
          type: value,
          groupId: this.storesActionGroup._id
            ? this.storesActionGroup._id
            : this.actionGroupData._id,
        },
      });
    },

    // allGroups: function watchAllGroups() {
    //   this.hintsGroups = this.allGroups;
    // },

    allActions: function watchAllActions() {
      this.hintsAction = this.allActions;
    },
    dates: async function watchDates(dates) {
      if (dates) {
        this.indCalendarDates.selected = 'Personalizado';
        this.indCalendarDates.start = this.dateFormat(dates.start);
        this.indCalendarDates.end = this.dateFormat(dates.end);
        this.myDates.start = dates.start;
        this.myDates.end = dates.end;
        this.myDates.selected = this.indCalendarDates.selected;
        this.$store.state.indicators.indicatorData.period = this.showPeriod();
        this.$store.state.indicators.indicatorData.range =
          this.indCalendarDates;
        this.$store.state.indicators.indicatorData.value = null;
        this.$store.state.indicators.indicatorData.key = null;
      }
    },

    indCalendarDates: function watchIndCalendarDates(value) {
      if (value.start === null) {
        this.myDates.start = null;
        this.myDates.end = null;
        this.dates.start = null;
        this.dates.end = null;
      }
    },
  },

  computed: {
    ...mapState('actions', [
      'myActionId',
      'myActionName',
      'actionGroup',
      'allActions',
      'favouriteGroup',
      'myActionsIds',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('companies', ['company', 'myMetric']),
    ...mapState('branches', [
      'ih1',
      'ih2',
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapFields('actions', ['actionGroupData', 'allGroups']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('calendar', ['calendarDates']),

    getIndicatorsPaginate() {
      let indicators;

      if (this.indicatorFilter) {
        if (this.limit >= this.indicatorFilter.length) {
          document.querySelector('#loadmore').style.display = 'none';
        } else {
          document.querySelector('#loadmore').style.display = 'block';
        }

        indicators = this.indicatorFilter.slice(0, this.limit);

        if (indicators.length < 19) {
          document.querySelector('#loadmore').style.display = 'none';
        }
      }

      return indicators;
    },

    getIndicatorsValuePaginate() {
      let indicators;

      if (this.indicatorDataFilter) {
        if (this.limitValue >= this.indicatorDataFilter.length) {
          document.querySelector('#loadmore-indic-value').style.display =
            'none';
        } else {
          document.querySelector('#loadmore-indic-value').style.display =
            'block';
        }

        indicators = this.indicatorDataFilter.slice(0, this.limitValue);

        if (indicators.length < 19) {
          document.querySelector('#loadmore-indic-value').style.display =
            'none';
        }
      }

      return indicators;
    },
  },

  methods: {
    ...mapActions('branches', [
      'setIh1',
      'setMyHierarchies1',
      'setIh2',
      'setMyHierarchies2',
      'listBranchesIh1',
      'listBranchesIh2',
    ]),
    ...mapActions('companies', ['setMetric']),
    ...mapActions('actions', [
      'getAllActions',
      'setActionsIds',
      'getAllActionGroups',
    ]),

    async updateListIndicators() {
      const response = await api.get(
        `/filters/indicators/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId:
              this.storeMyActionsIds.length === 0
                ? null
                : this.storeMyActionsIds.join(','),
            groupId: this.storesActionGroup._id,
          },
        },
      );

      this.indicators = response.data.indicators;
      this.dateIndicators = response.data.dateIndicators;
      this.indicatorFilter = this.indicators;
    },

    async updateListActions(){
      this.loadingAction = true;
      this.allActionData = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              type: this.storesMetric,
              groupId: this.storesActionGroup._id
            },
          },
        );

      this.hintsAction = this.allActionData.data;

      this.loadingAction = false;
    },

    async updateListIndicatorValue() {
      this.loadingIndicatorValue = true;
      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: this.storeIndicatorDataName,
            groupId: this.storesActionGroup._id
              ? this.storesActionGroup._id
              : this.actionGroupData._id,
            actionId:
              this.storeMyActionsIds.length === 0
                ? null
                : this.storeMyActionsIds.join(','),
            ih1:
              this.storeMyHierarchies1.length === 0
                ? null
                : this.storeMyHierarchies1.join(','),
            ih2:
              this.storeMyHierarchies2.length === 0
                ? null
                : this.storeMyHierarchies2.join(','),
            startDate: this.calendarDates.start
              ? this.calendarDates.start
              : null,
            endDate: this.calendarDates.end ? this.calendarDates.end : null,
          },
        },
      );
      this.allIndicatorData = response.data;
      this.indicatorDataFilter = this.allIndicatorData;
      this.loadingIndicatorValue = false;
    },

    removeIh1ById(ih1Id) {
      const indexMyHierarchies1 = this.storeMyHierarchies1.indexOf(ih1Id);
      this.storeMyHierarchies1.splice(indexMyHierarchies1, 1);
    },

    removeIh2ById(ih2Id) {
      const indexMyHierarchies2 = this.storeMyHierarchies2.indexOf(ih2Id);
      this.storeMyHierarchies2.splice(indexMyHierarchies2, 1);
    },

    returnMyIh1Name(ih1Id) {
      if (ih1Id) {
        const ih1ById = this.ih1.allBranches.find((item) => item._id === ih1Id);
        if (ih1ById) {
          return ih1ById.corporate_name;
        }
      }

      return '-';
    },

    returnMyIh2Name(ih2Id) {
      if (ih2Id) {
        const ih2ById = this.ih2.allBranches.find((item) => item._id === ih2Id);
        return ih2ById.corporate_name;
      }

      return '-';
    },

    removeActionById(actionId) {
      const indexAction = this.storeMyActionsIds.indexOf(actionId);
      this.storeMyActionsIds.splice(indexAction, 1);
    },

    async returnListActionUpdated(){
       const actions = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              type: this.storesMetric,
              groupId: this.storesActionGroup._id
            },
          },
        );

        this.hintsAction = actions.data;
     },

     returnActionName(actionId) {
      if (actionId) {
        const actionById = this.allActions.find(
          (item) => item._id === actionId,
        );

        if (actionById) {
          return actionById.name;
        }
      }

      return null;
    },

    async loadIh1Ih2() {
      let query = {
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        page: this.currentPage,
        limit: 20,
      };

      this.loadingActions = true;

      query = { ...query, type: 'ih1' };

      this.loadingIh1 = true;

      await this.listBranchesIh1(query).then(() => {
        this.loadingIh1 = false;
      });

      query = { ...query, type: 'ih2' };

      this.loadingIh2 = true;

      await this.listBranchesIh2(query).then(() => {
        this.loadingIh2 = false;
      });
    },

    async loadIh2() {
      let query = {
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        page: this.currentPageIh2,
        limit: 20,
      };
      query = { ...query, type: 'ih2' };
      this.loadingIh2 = true;
      await this.listBranchesIh2(query);
      this.loadingIh2 = false;
    },

    async searchIh1() {
      if (this.boxIh1 === null || this.boxIh1 === '') {
        setTimeout(() => {
          this.loadIh1Ih2();
        }, 600);
      } else {
        this.loadingIh1 = true;
        setTimeout(async () => {
          const response = await api.get(
            `/branches/${this.userAuth.companyId}/search`,
            {
              headers: { 'x-access-token': this.userAuth.token },
              params: {
                companyId: this.userAuth.companyId,
                token: this.userAuth.token,
                filter: this.boxIh1,
                type: 'ih1',
              },
            },
          );

          this.ih1.listFilters = response.data.branches;
          this.hintsIh1 = response.data.branches;
          this.loadingIh1 = false;
        }, 1000);
      }
    },

    async searchIh2() {
      if (this.boxIh2 === null || this.boxIh2 === '') {
        setTimeout(() => {
          this.loadIh2();
        }, 600);
      } else {
        this.loadingIh2 = true;
        setTimeout(async () => {
          const response = await api.get(
            `/branches/${this.userAuth.companyId}/search`,
            {
              headers: { 'x-access-token': this.userAuth.token },
              params: {
                companyId: this.userAuth.companyId,
                token: this.userAuth.token,
                filter: this.boxIh2,
                type: 'ih2',
              },
            },
          );
          this.ih2.listFilters = response.data.branches;
          this.hintsIh2 = response.data.branches;
          this.loadingIh2 = false;
        }, 1000);
      }
    },

    async searchIh2(){

if (this.boxIh2 === null || this.boxIh2 === '') {
  setTimeout(()=>{
    this.loadIh2()
  },600)
} else {
  this.loadingIh2 = true;
  setTimeout(async ()=>{
    const response = await api.get(
      `/branches/${this.userAuth.companyId}/search`,
      {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          filter: this.boxIh2,
          type: 'ih2',
        },
      },
    );

    this.ih2.listFilters = response.data.branches
    this.hintsIh2 = response.data.branches;
    this.loadingIh2 = false;
  }, 1000)

}
},

    loadMore() {
      this.limit = this.limit + 20;
    },

    loadMoreIndicValue() {
      this.limitValue = this.limitValue + 20;
    },

    cleanIndicatorFilter() {
      this.$store.state.indicators.indicatorName = null;
      this.$store.state.indicators.indicatorData.value = null;
      this.$store.state.indicators.indicatorData.key = null;
      this.$store.state.indicators.indicatorData.period = null;
      this.$store.state.indicators.indicatorData.range.start = null;
      this.$store.state.indicators.indicatorData.range.selected = null;
      this.$store.state.indicators.indicatorData.range.end = null;

      this.storeIndicatorDataValue = null;
      this.storeIndicatorDataKey = null;
      this.storeIndicatorDataPeriod = null;
      this.storeIndicatorDataName = null;

      const infoIndicators = {
        indicatorName: null,
        indicatorData: {
          key: null,
          value: null,
          period: null,
        },
      };

      EventBus.$emit('update-indicators', infoIndicators);
    },

    cleanIndicatorDataFilter() {
      this.$store.state.indicators.indicatorData.value = null;
      this.$store.state.indicators.indicatorData.key = null;
      this.$store.state.indicators.indicatorData.period = null;
      this.$store.state.indicators.indicatorData.range.start = null;
      this.$store.state.indicators.indicatorData.range.selected = null;
      this.$store.state.indicators.indicatorData.range.end = null;

      this.storeIndicatorDataValue = null;
      this.storeIndicatorDataKey = null;
      this.storeIndicatorDataPeriod = null;
      this.storeIndicatorDataName = null;
    },
    cleanActionDataFilter() {
      this.action = null;
      this.storesActions = null;
      this.storeMyActionsIds = [];
      this.storeMyActionId = null;
      this.filterAction();
    },
    cleanActionGroupDataFilter() {
      this.groupName = null;
       this.storesActionGroup = {
        _id: null,
        name: 'Sem classificação',
      };
      if (
        this.myMetric !== this.favouriteGroup.metric &&
        this.favouriteGroup.metric
      ) {
        this.setMetric(this.company.favoriteMetric);
        this.metric = this.company.favoriteMetric;

        this.actionGroupData._id = this.favouriteGroup._id;
        this.actionGroupData.name = this.favouriteGroup.name;
      } else {
        this.actionGroupData = {
          _id: this.favouriteGroup._id,
          name: this.favouriteGroup.name,
        };
      }
      this.clearAllActionDataForStore();
    },
    checkIndicatorData() {
      if (this.loading) {
        return this.$t('menu.filter.loading');
      } else if (this.storeIndicatorDataValue) {
        return this.$t('menu.filter.indicators', {
          indicatorData: `${this.storeIndicatorDataValue}`,
        });
      }
      return this.$t('menu.filter.indicatorData');
    },

    filterIndicator() {
      if (this.indicatorSelected === null || this.indicatorSelected === '') {
        this.indicatorFilter = this.indicators;
      } else {
        const res = searchByIndicatorText(
          this.indicators,
          this.indicatorSelected,
        );
        this.indicatorFilter = res;
      }
    },

    filterIndicatorData() {
      if (
        this.indicatorDataSelected === null ||
        this.indicatorDataSelected === ''
      ) {
        this.indicatorDataFilter = this.allIndicatorData;
      } else {
        const res = searchByIndicatorText(
          this.allIndicatorData,
          this.indicatorDataSelected,
        );
        this.indicatorDataFilter = res;
      }
    },

    async handleIndicatorData(text, key) {
      if (this.indicatorDataFilter.length > 0) {
        this.storeIndicatorDataValue = text;
        this.storeIndicatorDataKey = key;
        this.storeIndicatorDataPeriod = null;

        // this.$store.state.indicators.indicatorData.value = text;
        // this.$store.state.indicators.indicatorData.key = key;
        // this.$store.state.indicators.indicatorData.period = null;
      }
    },

    clearAllActionDataForStore() {
      this.action = null;
      this.$store.state.actions.myActionId = '0';
      this.$store.state.actions.myActionsIds = [];
      this.$store.state.actions.myActionName = this.$t('menu.allActionsLabel');
      // this.cleanIndicatorFilter();
      // this.cleanIndicatorDataFilter();
      this.handleIndicator();
    },

    async handleIndicator() {
      const response = await api.get(
        `/filters/indicators/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            // actionId: this.myActionId === '0' ? null : this.myActionId,
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            groupId: this.actionGroupData._id,
          },
        },
      );

      this.indicators = response.data.indicators;
      this.dateIndicators = response.data.dateIndicators;
      this.indicatorFilter = this.indicators;
    },

    isDateIndicator(value) {
      if (this.dateIndicators) {
        for (let i = 0; i < this.dateIndicators.length; i += 1) {
          if (this.dateIndicators[i]._id === value) {
            return true;
          }
        }
      }
      return false;
    },

    async setIndicatorValue(value) {
      this.loading = true;
      if (this.indicatorFilter.length > 0) {
        // this.$store.state.indicators.indicatorData.value = null;
        // this.$store.state.indicators.indicatorData.key = null;
        // this.$store.state.indicators.indicatorData.period = null;
        // this.$store.state.indicators.indicatorName = value;

        this.storeIndicatorDataValue = null;
        this.storeIndicatorDataKey = null;
        this.storeIndicatorDataPeriod = null;
        this.storeIndicatorDataName = value;

        if (!this.isDateIndicator(value)) {
          const response = await api.get(
            `/filters/indicator-data/${this.userAuth.companyId}`,
            {
              headers: { 'x-access-token': this.userAuth.token },
              params: {
                indicatorValue: value,
                groupId: this.actionGroupData._id,
                // actionId: this.myActionId === '0' ? null : this.myActionId,
                actionId:
                  this.storeMyActionsIds.length === 0
                    ? null
                    : this.storeMyActionsIds.join(','),
                ih1:
                  this.storeMyHierarchies1.length === 0
                    ? null
                    : this.storeMyHierarchies1.join(','),
                ih2:
                  this.storeMyHierarchies2.length === 0
                    ? null
                    : this.storeMyHierarchies2.join(','),
                startDate: this.calendarDates.start
                  ? this.calendarDates.start
                  : null,
                endDate: this.calendarDates.end ? this.calendarDates.end : null,
              },
            },
          );
          this.allIndicatorData = response.data;
          this.indicatorDataFilter = this.allIndicatorData;
        } else {
          this.indCalendarDates.selected = 'Todo período';
          // this.$store.state.indicators.indicatorData.period = this.showPeriod();
          this.storeIndicatorDataPeriod = this.showPeriod();
        }
      }
      this.loading = false;
    },

    async getAllAvailableMetrics() {
      const response = await api.get(
        `${process.env.API_ROOT}/action-verify-metrics/${this.userAuth.companyId}`,
        { headers: { 'x-access-token': this.userAuth.token } },
      );

      this.metricOptions = response.data;
    },

    async setActionGroup(apply, group) {
      this.storesActionGroup = group;


      if (apply) {
        this.clearAllActionDataForStore();
        if (!group.metric) {
          if (this.metric !== this.company.favoriteMetric) {
            this.setMetric(this.company.favoriteMetric);
            this.metric = this.company.favoriteMetric;
            this.actionGroupData._id = group._id;
            this.actionGroupData.name = group.name;
          } else {
            this.actionGroupData = {
              _id: group._id,
              name: group.name,
            };
          }
        } else if (this.metric !== group.metric) {
          this.setMetric(group.metric);
          this.metric = group.metric;

          this.actionGroupData._id = group._id;
          this.actionGroupData.name = group.name;
        } else {
          this.actionGroupData = {
            _id: group._id,
            name: group.name,
          };
        }

        if (!this.company.indicatorIh1) {
          this.company.indicatorIh1 = 'indicador 1';
        }

        await this.getAllActions({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          params: {
            type: this.myMetric,
            groupId: this.storesActionGroup._id
              ? this.storesActionGroup._id
              : this.actionGroupData._id,
          },
        });

        this.hintsAction = this.allActions;
      } else {
        this.allActionData = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              type: this.storesMetric,
            },
          },
        );

        this.hintsAction = this.allActionData;

        if (this.metric !== this.storesMetric) {
          // this.storesActionGroup = {
          //   _id: null,
          //   name: 'Sem classificação',
          // };

          // this.setActionGroup(false, this.storesActionGroup);
        }

        this.myActionsIds = [];
        this.storeMyActionsIds = [];
        this.myActionName = [];
      }
    },

    async updateListGroupAction() {
      const response = await api.get(
        `filters/action-groups/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            menuAside: true,
            metric: this.storesMetric,
          },
        },
      );

      this.hintsGroups = response.data;
    },

    async apply() {

      if (this.storesMetric) {
        this.setMetric(this.storesMetric);
      }

      if (this.storesActionGroup) {
        this.setActionGroup(true, this.storesActionGroup);
      }

      if (this.storeMyHierarchies1Id) {
        this.setValIh1(true, this.storeMyHierarchies1Id);
      }

      if (this.storeMyHierarchies2Id) {
        this.setValIh2(true, this.storeMyHierarchies2Id);
      }

      if (this.storeMyActionName) {
        this.setValAction(true, this.storeMyActionId, this.storeMyActionName);
      }

      const infoIndicators = {
        indicatorName: this.storeIndicatorDataName,
        indicatorData: {
          key: this.storeIndicatorDataKey,
          value: this.storeIndicatorDataValue,
          period: this.storeIndicatorDataPeriod
            ? this.storeIndicatorDataPeriod
            : null,
        },
      };

      EventBus.$emit('update-indicators', infoIndicators);

      if (
        this.storeIndicatorDataName &&
        this.storeIndicatorDataValue &&
        this.storeIndicatorDataKey
      ) {
        this.$store.state.indicators.indicatorName =
          this.storeIndicatorDataName;
        this.$store.state.indicators.indicatorData.value =
          this.storeIndicatorDataValue;
        this.$store.state.indicators.indicatorData.key =
          this.storeIndicatorDataKey;
        this.$store.state.indicators.indicatorData.period = this
          .storeIndicatorDataPeriod
          ? this.storeIndicatorDataPeriod
          : null;
      }

      EventBus.$emit('apply-filter-menu', true);
      this.hideMenu();
    },

    hideMenu() {
      EventBus.$emit('close-filter-menu', false);
      this.storesMetric = '';
      this.storesActionGroup = {
        _id: null,
        name: 'Sem classificação',
      };
      this.storeMyActionsIds = [];
      this.storeMyActionName = '';
      this.storesActions = '';
      this.storeMyActionId = '';

      if (this.turnOffTheLight) {
        this.style.right = '-550px';
        this.turnOffTheLight = false;
      } else {
        this.style.right = 0;
        this.turnOffTheLight = true;
      }
    },

    showHideMenu(show) {
      if (show) {
        this.style.right = 0;
        this.turnOffTheLight = true;
      } else {
        this.style.right = '-550px';
        this.turnOffTheLight = false;
      }
    },

    async reloadMetricFilter() {
      await this.getAllAvailableMetrics();
    },

    searchByGroupName() {
      if (this.groupName) {
        const filter = this.groupName.toLowerCase();

        this.hintsGroups = this.allGroups.filter((group) =>
          group.name.toLowerCase().includes(filter),
        );
      } else {
        this.hintsGroups = this.allGroups;
      }
    },

    filterIh1() {
      if (this.boxIh1 === null || this.boxIh1 === '') {
        this.hintsIh1 = this.ih1.listFilters;
        this.setIh1('0');
        this.myHierarchies1 = [];
      } else {
        const res = searchByItem(this.ih1.listFilters, this.boxIh1);
        this.hintsIh1 = res;
      }
    },

    setValIh1(apply, id) {
      if (apply) {
        this.setIh1(id);
        // this.setMyHierarchies1(this.storeMyHierarchies1);
        this.setMyHierarchies1(this.storeMyHierarchies1.slice());
      } else if (!apply) {
        if (
          this.storeMyHierarchies1.length > 0 &&
          !this.storeMyHierarchies1.includes(id)
        ) {
          this.storeMyHierarchies1.push(id);
          this.storeMyHierarchies1Id = this.storeMyHierarchies1[0];
        }

        if (this.storeMyHierarchies1.length === 0) {
          this.storeMyHierarchies1.push(id);
          this.storeMyHierarchies1Id = id;
        }
      }
    },

    enterSetValIh1() {
      const items = searchByItem(this.ih1.listFilters, this.boxIh1);
      if (items.length > 0) {
        const it = items.find(
          (obj) => toLower(obj.corporate_name) === toLower(this.boxIh1),
        );

        if (it) {
          this.setIh1(it._id);
          if (!this.myHierarchies1.includes(it._id)) {
            this.myHierarchies1.push(it._id);
          }
        }
      }
    },

    filterIh2() {
      if (this.boxIh2 === null || this.boxIh2 === '') {
        this.hintsIh2 = this.ih2.listFilters;
        this.setIh2('0');
        this.myHierarchies2 = [];
      } else {
        const res = searchByItem(this.ih2.listFilters, this.boxIh2);
        this.hintsIh2 = res;
      }
    },

    setValIh2(apply, id) {
      // this.setIh2(id);
      if (apply) {
        this.setIh2(id);
        // this.setMyHierarchies2(this.storeMyHierarchies2);
        this.setMyHierarchies2(this.storeMyHierarchies2.slice());
      } else if (!apply) {
        if (
          this.storeMyHierarchies2.length > 0 &&
          !this.storeMyHierarchies2.includes(id)
        ) {
          this.storeMyHierarchies2.push(id);
          this.storeMyHierarchies2Id = this.storeMyHierarchies2[0];
        }

        if (this.storeMyHierarchies2.length === 0) {
          this.storeMyHierarchies2.push(id);
          this.storeMyHierarchies2Id = id;
        }
      }
    },

    enterSetValIh2() {
      const items = searchByItem(this.ih2.listFilters, this.boxIh2);
      if (items.length > 0) {
        const it = items.find(
          (obj) => toLower(obj.corporate_name) === toLower(this.boxIh2),
        );

        if (it) {
          this.setIh2(it._id);
          if (!this.myHierarchies2.includes(it._id)) {
            this.myHierarchies2.push(it._id);
          }
        }
      }
    },

    filterAction() {
      if (this.action === null || this.action === '') {
        this.hintsAction = this.allActions;
        // this.$store.state.actions.myActionId = '0';
        // this.$store.state.actions.myActionsIds = [];

        // this.$store.state.actions.myActionName = this.$t(
        //   'menu.allActionsLabel',
        // );
      } else {
        const res = searchByItemAction(this.allActions, this.action);
        this.hintsAction = res;
      }
    },

    setValAction(apply, id, name) {
      // this.$store.state.actions.myActionId = id;
      //   if (!this.myActionsIds.includes(id)) {
      //    this.myActionsIds.push(id);
      // }
      // this.myActionName = name;

      if (apply) {
        EventBus.$emit('update-action-request');
        this.$store.state.actions.myActionId = id;
        this.$store.state.actions.myActionsIds = this.storeMyActionsIds;
        this.$store.state.actions.myActionName = name;


      } else if (!apply) {
        if (
          this.storeMyActionsIds.length > 0 &&
          !this.storeMyActionsIds.includes(id)
        ) {
          this.storeMyActionsIds.push(id);
        }

        if (this.storeMyActionsIds.length === 0) {
          this.storeMyActionsIds.push(id);
        }

        this.storeMyActionId = id;
        this.storeMyActionName = name;
      }
    },

    enterSetValAction() {
      const items = searchByItem(this.allActions.actions, this.action);
      if (items.length > 0) {
        const it = items.find(
          (obj) => toLower(obj.name) === toLower(this.action),
        );
        if (it) {
          this.$store.state.actions.myActionId = it._id;

          if (!this.$store.state.actions.myActionsIds.includes(it._id)) {
            this.$store.state.actions.myActionsIds.push(it._id);
          }

          this.$store.state.actions.myActionName = it.name;
        }
      }
    },

    resetFilters() {
      this.setIh1('0');
      this.setMyHierarchies1([]);
      this.setMyHierarchies2([]);
      this.setIh2('0');
      // this.$store.state.actions.myActionId = '0';
      this.$store.state.actions.myActionsIds = [];
      this.$store.state.actions.myActionName = this.$t('menu.allActionsLabel');
      this.boxIh1 = null;
      this.boxIh2 = null;
      this.action = null;
      this.hintsIh1 = this.ih1.listFilters;
      this.hintsIh2 = this.ih2.listFilters;
      this.hintsAction = this.allActions;
      this.groupName = null;
      this.$store.state.indicators.indicatorName = null;
      this.$store.state.indicators.indicatorData.value = null;
      this.$store.state.indicators.indicatorData.key = null;

      this.storesMetric = '';
      this.storesActionGroup = {
        _id: null,
        name: 'Sem classificação',
      };
      this.storesActions = '';
      this.storeMyActionsIds = [];
      this.storeMyActionName = '';
      this.storeMyActionId = '';
      this.storeMyHierarchies1 = [];
      this.storeMyHierarchies1Id = '';
      this.storeMyHierarchies2 = [];
      this.storeMyHierarchies2Id = '';
      this.storeIndicatorDataValue = '';
      this.storeIndicatorDataKey = '';
      this.storeIndicatorDataPeriod = '';
      this.storeIndicatorDataName = '';

      EventBus.$emit('resetFilterCategory');

      if (
        this.myMetric !== this.favouriteGroup.metric &&
        this.favouriteGroup.metric
      ) {
        this.setMetric(this.company.favoriteMetric);
        this.metric = this.company.favoriteMetric;

        this.actionGroupData._id = this.favouriteGroup._id;
        this.actionGroupData.name = this.favouriteGroup.name;
      } else {
        this.actionGroupData = {
          _id: this.favouriteGroup._id,
          name: this.favouriteGroup.name,
        };
      }

      this.clearAllActionDataForStore();
      const infoIndicators = {
        indicatorName: null,
        indicatorData: {
          key: null,
          value: null,
          period: null,
        },
      };

      EventBus.$emit('reset-filter-menu');
      EventBus.$emit('update-indicators', infoIndicators);
      this.hideMenu();
    },

    async changeMetric(metric) {
      // this.setMetric(metric);
      if (metric !== this.storesMetric) {
        this.storesActionGroup = {
          _id: null,
          name: 'Sem classificação',
        };

        this.allActionData = await api.get(
        `/filters/actions/${this.userAuth.companyId}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              type: this.storesMetric,
            },
          },
        );

        this.hintsAction = this.allActionData;

        // this.setActionGroup(false, this.storesActionGroup);
        this.storeMyActionsIds = [];
      }

      this.returnListActionUpdated();

      this.storesMetric = metric;
    },

    changeLabels() {
      this.fastFilter = [
        {
          value: 'Hoje',
          text: this.$t('dashboard.todayFilter'),
        },
        { value: 'Ontem', text: this.$t('dashboard.yesterdayFilter') },
        {
          value: 'Últimos 30 dias',
          text: this.$t('dashboard.last30DaysFilter'),
        },
        { value: 'Mês atual', text: this.$t('dashboard.currentMonthFilter') },
        { value: 'Mês anterior', text: this.$t('dashboard.lastMonthFilter') },
        { value: 'Ano atual', text: this.$t('dashboard.currentYearFilter') },
        { value: 'Ano anterior', text: this.$t('dashboard.lastYearFilter') },
        { value: 'Todo período', text: this.$t('dashboard.everyPeriodFilter') },
        {
          value: 'Personalizado',
          text: this.$t('dashboard.custom'),
          disabled: true,
        },
      ];
    },
    changeCalendarLanguage() {
      switch (this.$i18n.locale) {
        case 'br':
          this.countryLanguage = 'pt';
          break;
        case 'co':
          this.countryLanguage = 'es';
          break;
        case 'us':
          this.countryLanguage = 'en';
          break;
        default:
          break;
      }
    },

    selectOption(dates) {
      if (dates === 'Hoje') {
        this.calculateToday();
      }
      if (dates === 'Ontem') {
        this.calculateYesterday();
      }
      if (dates === 'Últimos 30 dias') {
        this.calculateLast30Days();
      }
      if (dates === 'Mês atual') {
        this.calculateCurrentMonth();
      }
      if (dates === 'Mês anterior') {
        this.calculateLastMonth();
      }
      if (dates === 'Ano atual') {
        this.calculateCurrentYear();
      }
      if (dates === 'Ano anterior') {
        this.calculateLastYear();
      }
      if (dates === 'Todo período') {
        this.allPeriod();
      }
      this.$store.state.indicators.indicatorData.period = this.showPeriod();
      this.$store.state.indicators.indicatorData.range = this.indCalendarDates;
      this.$store.state.indicators.indicatorData.value = null;
      this.$store.state.indicators.indicatorData.key = null;
    },

    calculateToday() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      this.myDates.start = date;
      this.myDates.end = date;
      this.indCalendarDates.selected = 'Hoje';
      this.indCalendarDates.start = this.dateFormat(date);
      this.indCalendarDates.end = this.dateFormat(date);
    },

    calculateYesterday() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      yesterday.setHours(0, 0, 0, 0);
      this.myDates.start = yesterday;
      this.myDates.end = yesterday;
      this.indCalendarDates.selected = 'Ontem';
      this.indCalendarDates.start = this.dateFormat(yesterday);
      this.indCalendarDates.end = this.dateFormat(yesterday);
    },

    calculateLast30Days() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      const firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
      firstDay.setHours(0, 0, 0, 0);
      this.myDates.start = firstDay;
      this.myDates.end = date;
      this.indCalendarDates.selected = 'Últimos 30 dias';
      this.indCalendarDates.start = this.dateFormat(firstDay);
      this.indCalendarDates.end = this.dateFormat(date);
    },

    calculateCurrentMonth() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      const y = date.getFullYear();
      const m = date.getMonth();
      const firstDay = new Date(y, m, 1);
      const lastDay = date;
      this.myDates.start = firstDay;
      this.myDates.end = lastDay;
      this.indCalendarDates.selected = 'Mês atual';
      this.indCalendarDates.start = this.dateFormat(firstDay);
      this.indCalendarDates.end = this.dateFormat(lastDay);
    },

    calculateLastMonth() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      const y = date.getFullYear();
      const m = date.getMonth();
      const firstDay = new Date(y, m - 1, 1);
      const lastDay = new Date(y, m, 0);
      this.myDates.start = firstDay;
      this.myDates.end = lastDay;
      this.indCalendarDates.selected = 'Mês anterior';
      this.indCalendarDates.start = this.dateFormat(firstDay);
      this.indCalendarDates.end = this.dateFormat(lastDay);
    },

    calculateCurrentYear() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      this.indCalendarDates.end = this.dateFormat(date);
      this.myDates.end = new Date(date);
      // pega primeiro dia do ano
      date.setMonth(0);
      date.setFullYear(date.getFullYear());
      date.setDate(1);
      this.myDates.start = date;
      this.indCalendarDates.selected = 'Ano atual';
      this.indCalendarDates.start = this.dateFormat(date);
    },

    calculateLastYear() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      const y = date.getFullYear();
      const startDateLastYear = new Date(y - 1, 0, 1);
      const endDateLastYear = new Date(y - 1, 11, 31);
      this.myDates.start = startDateLastYear;
      this.myDates.end = endDateLastYear;
      this.indCalendarDates.selected = 'Ano anterior';
      this.indCalendarDates.start = this.dateFormat(startDateLastYear);
      this.indCalendarDates.end = this.dateFormat(endDateLastYear);
    },
    showPeriod() {
      if (this.indCalendarDates.start === null) {
        return this.$t('dashboard.everyPeriodFilter');
      }
      return `${this.dateBrazillianFormat(
        this.myDates.start,
      )} a ${this.dateBrazillianFormat(this.myDates.end)}`;
    },

    dateFormat(param) {
      const date = format(param, 'yyyy-MM-dd');
      return date;
    },

    dateBrazillianFormat(param) {
      const date = new Date(param);
      date.setHours(date.getHours() + 3);
      const result = lightFormat(new Date(date), 'dd/MM/yyyy');
      return result;
    },
    async allPeriod() {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      this.indCalendarDates.selected = 'Todo período';
      this.indCalendarDates.start = null;
      this.indCalendarDates.end = this.dateFormat(date);
      this.dates.start = null;
      this.dates.end = date;
    },
    checkTimePeriod() {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const firstDayPreviousMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1,
      );
      this.myDates.start = firstDayPreviousMonth;
      this.myDates.end = currentDate;
      this.myDates.selected = this.indCalendarDates.selected;
      this.indCalendarDates.start = null;
      this.indCalendarDates.end = null;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.checkTimePeriod();
    this.changeLabels();
  },

  async mounted() {
    EventBus.$on('aside-menu', this.showHideMenu);

    EventBus.$on('aside-menu', async () => {
      const actionsIds = JSON.parse(JSON.stringify(this.myActionsIds));
      this.storeMyActionsIds = actionsIds;

      const myHierarchies1 = JSON.parse(JSON.stringify(this.myHierarchies1));
      this.storeMyHierarchies1 = myHierarchies1;

      const myHierarchies2 = JSON.parse(JSON.stringify(this.myHierarchies2));
      this.storeMyHierarchies2 = myHierarchies2;

      this.storesMetric = this.myMetric;

      this.storesActionGroup = {
        name: 'Sem classificação',
        _id: null
      }

      this.storesActionGroup.name = this.actionGroupData.name;
      this.storesActionGroup._id = this.actionGroupData._id;
    });

    EventBus.$on('apply-indicator-value', (infoIndicator) => {
      if (infoIndicator.indicatorName) {
        this.storeIndicatorDataName = infoIndicator
          ? infoIndicator.indicatorName
          : '';
        this.storeIndicatorDataValue = infoIndicator
          ? infoIndicator.indicatorData.value
          : '';
        this.storeIndicatorDataKey = infoIndicator
          ? infoIndicator.indicatorData.key
          : '';
        this.storeIndicatorDataPeriod = infoIndicator
          ? infoIndicator.indicatorData.period
          : '';
      }
    });

    EventBus.$on('newActionCreated', this.reloadMetricFilter);
    EventBus.$on('changedLanguage', () => {
      this.changeCalendarLanguage();
      this.changeLabels();
    });

    this.metric = this.myMetric;
    this.hintsGroups = this.allGroups;
    this.hintsIh1 = this.ih1.listFilters;
    this.hintsIh2 = this.ih2.listFilters;

    await Promise.all([
      this.getAllAvailableMetrics(),
      this.getAllActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        params: {
          type: this.myMetric,
          groupId: this.storesActionGroup._id
            ? this.storesActionGroup._id
            : this.actionGroupData._id,
        },
      }),
    ]);

    this.hintsAction = this.allActions;
    this.handleIndicator();
    this.loadIh1Ih2();
  },
};
</script>

<style lang="scss">
@import '@/themes/default/variables.scss';
.text-size {
  font-size: 16px;
  color: #606060;
}

.three-column {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  text-align: center;
  justify-items: center;
  align-items: center;
}

.tag-green {
  padding: 5px 12px;
  background: $primary;
  border-radius: 4px;
  color: #fff;
  min-width: 150px;
  max-width: 150px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.tag-blue {
  background: #5299f2;
  padding: 5px 12px;
  border-radius: 4px;
  color: #fff;
  min-width: 150px;
  max-width: 150px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.hide-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-outline-primary:hover {
  color: #fff;
}
.wrapper-aside-filters .dropdown-menu {
  max-height: 200px;
  overflow: auto;
}
.string--formater {
  display: block;
  font-size: 14px;
  width: 450px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.button--formater {
  display: block;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8em;
  margin: 0 auto;
}

.button--formater2 {
  display: block;
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8em;
  margin: 0 auto;
}
</style>

<style lang="scss" scoped>
.filter {
  font-size: 18px;
  margin-bottom: 0;
}

.filter::before,
.filter::after {
  content: '';
  display: inline-block;
  width: 40%;
  border-top: 1px solid rgba(0, 0, 0, 0.25);
  vertical-align: middle;
}

.filter::before {
  margin-right: 5px;
}

.filter::after {
  margin-left: 5px;
}

hr {
  margin-bottom: 5px;
  margin-top: 5px;
}
.filters-overflow {
  max-height: 80px;
  overflow: auto;
}

.btn-loadmore {
  border: none;
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  color: #4ce595;
  border-radius: 4px;
  background-color: #fff;
}

.wrapper-aside-filters {
  .turn-off-the-lights {
    width: auto;
    height: calc(100vh - 70px);
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.5;
  }
  .aside-menu {
    position: absolute;
    background-color: #fff;
    height: calc(100vh - 70px);
    min-height: 100%;
    top: 0;
    transition: all 0.2s linear;
    z-index: 1035;
    padding: 16px;
    border-left: 1px solid rgba(0, 0, 0, 0.09);
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
.calendar-icon {
  color: #4ce595;
  cursor: pointer;
  &:hover {
    color: rgb(97, 209, 97);
    ~ .calendar {
      display: block;
    }
  }
}
.eraser-icon {
  position: absolute;
  top: 4px;
  right: 15px;
  font-size: 21px;
}
.choose-date {
  display: flex;
  border: solid #4ce595 1px;
  border-radius: 30px;
  margin: 20px;
}
#selectDateOption .custom-select {
  border-radius: 15px;
}

.pagination-area-ih1 >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-ih1 .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-ih1 a {
  outline: none;
}
.pagination-area-ih1 {
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/aside/index.vue